"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioNativeProjectSettingsResponseModelStatus = void 0;
exports.AudioNativeProjectSettingsResponseModelStatus = {
    Processing: "processing",
    Ready: "ready",
};
